const help = {
  // 随机数
  guid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4()
  },
  // 过滤对象中值为空的情况
  dataInit(data) {
    // 当对象为formdata类型直接返回对象
    if (Object.prototype.toString.call(data) === '[object FormData]') {
      return data
    }
    // 简易深拷贝
    const str = JSON.stringify(data)
    const newData = JSON.parse(str)
    for (let key in newData) {
      if (!newData[key] && newData[key] !== 0 && newData[key] !== false) {
        delete newData[key]
      }
    }
    if (newData.like) {
      newData.like = newData.like.replace(/(^\s*)|(\s*$)/g, '')
    }
    return newData
  },

  // 无闪现下载
  download(url, filename, callback) {
    var x = new XMLHttpRequest()
    x.open('GET', url, true)
    x.responseType = 'blob'
    x.onload = () => {
      var url = window.URL.createObjectURL(x.response)
      var a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
    }
    // 下载进度(%) progress
    x.onprogress = event => {
      if (event.lengthComputable && callback) {
        const progress = parseInt(
          ((event.loaded / event.total) * 100).toFixed(0)
        )
        callback(progress)
      }
    }
    x.send()
  },

  delHtmlTag(str) {
    return str ? str.replace(/<[^>]+>/g, '') : str //去掉所有的html标记
  },

  // 防抖
  debounce(fn, delay) {
    var timer // 维护一个 timer
    return function() {
      var _this = this // 取debounce执行作用域的this
      var args = arguments
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(function() {
        fn.apply(_this, args) // 用apply指向调用debounce的对象，相当于_this.fn(args);
      }, delay)
    }
  },

  // 节流
  throttle(fn, delay) {
    var timer
    return function() {
      var _this = this
      var args = arguments
      if (timer) {
        return
      }
      timer = setTimeout(function() {
        fn.apply(_this, args)
        timer = null // 在delay后执行完fn之后清空timer，此时timer为假，throttle触发可以进入计时器
      }, delay)
    }
  },

  // 获取元素相对页面的绝对位置
  getElementLeft(element) {
    var actualLeft = element.offsetLeft
    var current = element.offsetParent
    while (current !== null) {
      actualLeft += current.offsetLeft + current.clientLeft
      current = current.offsetParent
    }
    return actualLeft
  },

  getElementTop(element) {
    var actualTop = element.offsetTop
    var current = element.offsetParent
    while (current !== null) {
      actualTop += current.offsetTop + current.clientTop
      current = current.offsetParent
    }
    return actualTop
  },

  // 复制到粘贴板
  copyToBlock(val) {
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.setAttribute('value', val)
    input.select()
    if (document.execCommand('copy')) {
      document.execCommand('copy')
    }
    document.body.removeChild(input)
  },

  isObject(val) {
    return Object.prototype.toString.call(val) == '[object Object]'
  },
  isArray(val) {
    return Object.prototype.toString.call(val) == '[object Array]'
  },
  isString(val) {
    return Object.prototype.toString.call(val) == '[object String]'
  },

  // 判断数组是否有元素重叠
  arrIncludes(arr1, arr2) {
    if (!help.isArray(arr1) || !help.isArray(arr2)) {
      return false
    }
    const flag = arr2.some(item => {
      if (arr1.includes(item)) {
        return true
      }
    })
    return flag
  },

  //手动触发窗口resize事件
  doResize() {
    setTimeout(function() {
      if (document.createEvent) {
        var event = document.createEvent('HTMLEvents')
        event.initEvent('resize', true, true)
        window.dispatchEvent(event)
      } else if (document.createEventObject) {
        window.fireEvent('onresize')
      }
    }, 0)
  },

  // 货币换算
  formatMoney(number, places = 2, symbol = '$') {
    number = number || 0
    places = !isNaN((places = Math.abs(places))) ? places : 2
    symbol = symbol !== undefined ? symbol : '￥'
    var negative = number < 0 ? '-' : '',
      i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + '',
      j = (j = i.length) > 3 ? j % 3 : 0
    return (
      symbol +
      negative +
      (j ? i.substr(0, j) + ',' : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + ',') +
      (places
        ? '.' +
          Math.abs(number - i)
            .toFixed(places)
            .slice(2)
        : '')
    )
  },

  // 打开新窗口
  openWindow(url) {
    var isTop = (window.screen.height - 30 - 500) / 2
    var isLeft = (window.screen.width - 30 - 1000) / 2
    window.open(
      url,
      '',
      `height=500, width=1000, top=${isTop},left=${isLeft},right=200`
    )
  },

  // 关闭时间组件input表单自动填充
  closeAutocomplete() {
    const inputTags = document.getElementsByClassName('vue-input')
    const len = inputTags.length
    for (var i = 0; i < len; i++) {
      inputTags[i].setAttribute('autocomplete', 'off')
    }
  }
}

export default help
